export enum StoppageSource {
  Cockpit = 'cockpit',
  Janus = 'janus'
}

export enum StoppageType {
  Kiln = 'kiln',
  Other = 'other',
  CementMill = 'cementMill',
  RawMill = 'rawMill',
  CoalMill = 'coalMill',
  Crusher = 'crusher',
  VerticalMill = 'verticalMill',
  RollerPress = 'rollerPress',
  DosingEquipment = 'dosingEquipment',
  BallMill = 'ballMill',
  AlternativeFuelInstallation = 'alternativeFuelInstallation',
  Bypass = 'bypass'
}

export type StoppageCategoryCounts = {
  month: number
  year: number
  electricalCount: number
  mechanicalCount: number
  processCount: number
  otherCount: number
}

type FailureType = {
  plantId: string
  year: number
  failureTypePlannedNumber: number
  failureTypeCircumstanceNumber: number
  failureTypeIncidentNumber: number
}

export type StoppagesFailureTypesResponse = {
  success: boolean
  errorMessage: string
  failureTypes: FailureType[]
}
